module.exports = __webpack_public_path__ + "static/media/Screenshot at Nov 09 17-20-19_1573299909415.69e63d1d.png";